import type { Dict } from './uk';

/** Romanian (Moldova site). TODO: review by a native speaker before launch. */
export const ro: Dict = {
  'app.skip': 'Treceți la conținut',
  'app.loading': 'Se încarcă…',
  'nav.cases': 'Dosarele mele',
  'nav.privacy': 'Datele mele',
  'nav.main': 'Navigare principală',
  'lang.label': 'Limba',
  'theme.label': 'Aspect',
  'theme.system': 'Ca în sistem',
  'theme.light': 'Luminos',
  'theme.dark': 'Întunecat',

  'common.retry': 'Încercați din nou',
  'common.back': 'Înapoi',
  'common.cabinet': 'Cont personal',

  'login.title': 'Autentificare',
  'login.intro': 'Aici vedeți cum avansează dosarul, ne puteți trimite documente și îi puteți scrie managerului. Nu aveți nevoie de parolă — vă trimitem un cod unic.',
  'login.method': 'Cum trimitem codul',
  'login.byPhone': 'SMS pe telefon',
  'login.byEmail': 'E-mail',
  'login.phoneLabel': 'Număr de telefon',
  'login.emailLabel': 'Adresă de e-mail',
  'login.destHint': 'Cel pe care l-ați comunicat managerului nostru.',
  'login.phonePlaceholder': '+373 60 000 000',
  'login.emailPlaceholder': 'nume@example.com',
  'login.submit': 'Primiți codul',
  'login.sending': 'Se trimite…',
  'login.codeTitle': 'Introduceți codul',
  'login.codeSentPhone': 'Am trimis un SMS la {dest}.',
  'login.codeSentEmail': 'Am trimis un e-mail la {dest}.',
  'login.codeNote': 'Dacă avem aceste date de contact, codul va sosi într-un minut. Este valabil 10 minute.',
  'login.codeLabel': 'Cod din 6 cifre',
  'login.verify': 'Intrați',
  'login.verifying': 'Verificăm…',
  'login.resend': 'Trimiteți codul din nou',
  'login.resendIn': 'Puteți cere un cod nou peste {time}',
  'login.resent': 'Am trimis un cod nou.',
  'login.change': 'Schimbați telefonul sau e-mailul',
  'login.help': 'Nu primiți codul? Sunați-ne — vă ajutăm.',
  'login.empty': 'Vă rugăm să introduceți numărul de telefon sau e-mailul.',

  'err.invalid_destination': 'Pare să existe o greșeală în număr sau adresă. Vă rugăm să verificați.',
  'err.invalid_code': 'Codul nu este corect sau a expirat. Verificați cifrele sau cereți un cod nou.',
  'err.rate_limited': 'Prea multe încercări. Vă rugăm să așteptați câteva minute și să încercați din nou.',
  'err.rate_limited_wait': 'Prea multe încercări. Puteți încerca din nou peste {time}.',
  'err.network': 'Nu există conexiune. Verificați internetul și încercați din nou.',
  'err.unauthorized': 'Sesiunea a expirat. Vă rugăm să vă autentificați din nou.',
  'err.forbidden': 'Nu aveți acces la această pagină.',
  'err.not_found': 'Nu am găsit această pagină sau document.',
  'err.validation': 'Vă rugăm să verificați datele introduse.',
  'err.generic': 'Ceva nu a funcționat. Încercați din nou sau scrieți-ne în chat.',
  'err.code_incomplete': 'Introduceți toate cele 6 cifre ale codului.',

  'cases.title': 'Dosarele mele',
  'cases.empty': 'Încă nu există dosare aici. Dacă tocmai ne-ați contactat, dosarul va apărea după discuția cu managerul.',
  'cases.number': 'Dosarul nr. {n}',
  'cases.updated': 'Actualizat {date}',
  'cases.now': 'Acum',
  'cases.open': 'Deschideți dosarul',

  'case.sections': 'Secțiunile paginii',
  'case.stages': 'Etape',
  'case.stage.done': 'Finalizat',
  'case.stage.current': 'Acum',
  'case.stage.next': 'Urmează',
  'case.needs': 'De ce avem nevoie de la dumneavoastră',
  'case.needsIntro': 'Fotografiați documentul cu telefonul sau alegeți un fișier. Important este ca textul să se vadă clar.',
  'case.needsDone': 'Vă mulțumim. Momentan nu avem nevoie de nimic de la dumneavoastră.',
  'case.needsCount': 'Au rămas: {n}',
  'case.rejectedReason': 'Ce trebuie corectat: {reason}',
  'case.rejectedNoReason': 'Managerul vă va explica în chat ce trebuie corectat.',
  'case.replaceHint': 'Ați trimis un fișier greșit? Puteți trimite altul până îl verificăm.',

  'status.missing': 'Necesar',
  'status.optional': 'Opțional',
  'status.uploaded': 'Se verifică',
  'status.accepted': 'Acceptat',
  'status.rejected': 'De refăcut',

  'upload.takePhoto': 'Faceți o fotografie',
  'upload.chooseFile': 'Alegeți un fișier',
  'upload.replace': 'Trimiteți alt fișier',
  'upload.limits': 'Fotografie sau PDF, până la {mb} MB.',
  'upload.preparing': 'Pregătim…',
  'upload.uploading': 'Se încarcă: {pct}%',
  'upload.finishing': 'Salvăm…',
  'upload.done': 'Fișier primit. Îl vom verifica în curând.',
  'upload.tooLarge': 'Fișierul este prea mare ({size}). Limita este {mb} MB. Încercați să faceți din nou fotografia sau să micșorați PDF-ul.',
  'upload.badType': 'Acest tip de fișier nu este acceptat. Sunt potrivite fotografiile (JPG, PNG, HEIC) sau PDF.',
  'upload.empty': 'Fișierul este gol. Alegeți-l din nou.',
  'upload.failed': 'Fișierul nu a putut fi încărcat.',
  'upload.retry': 'Încercați din nou',
  'upload.cancel': 'Anulați',
  'upload.progress': 'Progresul încărcării',

  'docs.fromUs': 'Documente de la noi',
  'docs.empty': 'Documentele pe care le pregătim vor apărea aici.',
  'docs.download': 'Descărcați',
  'docs.opening': 'Se deschide…',
  'docs.yours': 'Trimise de dumneavoastră',

  'chat.title': 'Chat cu managerul',
  'chat.intro': 'Scrieți când vă este comod. Managerul vă va răspunde cât mai curând.',
  'chat.urgentCall': 'Pentru situații urgente, mai bine sunați:',
  'chat.empty': 'Încă nu există mesaje. Puteți pune orice întrebare.',
  'chat.label': 'Mesajul dumneavoastră',
  'chat.placeholder': 'Scrieți un mesaj…',
  'chat.send': 'Trimiteți',
  'chat.sending': 'Se trimite…',
  'chat.failed': 'Netrimis.',
  'chat.retry': 'Trimiteți din nou',
  'chat.you': 'Dumneavoastră',
  'chat.manager': 'Manager',
  'chat.offline': 'Nu există conexiune. Mesajele noi vor apărea când conexiunea revine.',

  'timeline.title': 'Istoric',
  'timeline.empty': 'Încă nu există evenimente.',
  'event.case_created': 'Dosar deschis',
  'event.state_changed': 'Etapă nouă: {state}',
  'event.state_changed_plain': 'Dosarul a trecut la o etapă nouă',
  'event.document_uploaded': 'Document primit: {doc}',
  'event.document_accepted': 'Document acceptat: {doc}',
  'event.documents_accepted': 'Documente acceptate: {docs}',
  'event.documents_uploaded': 'Documente primite: {docs}',
  'event.document_rejected': 'Documentul trebuie refăcut: {doc}',
  'event.document_ready': 'Document pregătit: {doc}',
  'event.document_plain': 'Actualizare privind documentele',
  'event.message': 'Mesaj nou de la manager',
  'event.generic': 'Actualizare în dosar',
  'event.order_shipped': 'Comanda a fost expediată',
  'event.order_completed': 'Comanda a fost finalizată',

  'privacy.title': 'Datele mele',
  'privacy.intro': 'Păstrăm doar ceea ce este necesar pentru dosarul dumneavoastră și nu le transmitem fără motiv.',
  'privacy.exportTitle': 'O copie a datelor dumneavoastră',
  'privacy.exportHint': 'Un fișier cu tot ce păstrăm despre dumneavoastră (conform GDPR).',
  'privacy.export': 'Descărcați datele mele',
  'privacy.exporting': 'Pregătim fișierul…',
  'privacy.exported': 'Fișierul a fost salvat pe dispozitiv.',
  'privacy.erase': 'Dacă doriți să vă ștergem datele, scrieți-ne. Vă răspundem în 30 de zile.',
  'privacy.contacts': 'Contacte',
  'privacy.phone': 'Telefon',
  'privacy.duty': 'Non-stop',
  'privacy.email': 'E-mail',
  'privacy.dpo': 'Întrebări despre date',
  'privacy.company': 'Companie',
  'privacy.address': 'Adresă',
  'privacy.session': 'Ieșire',
  'privacy.logoutHint': 'Dacă folosiți telefonul sau calculatorul altcuiva, ieșiți din cont la final.',
  'privacy.logout': 'Ieșiți din cont',
  'privacy.loggingOut': 'Ieșim…',

  // --- phase 5: steps, notifications, feedback, case site
  'nav.notifications': 'Notificări',
  'notif.title': 'Notificări',
  'notif.intro': 'Aici se păstrează toate mesajele despre dosarele dumneavoastră, chiar dacă un e-mail sau un SMS nu a ajuns.',
  'notif.empty': 'Deocamdată nu există notificări.',
  'notif.via.email': 'Trimis pe e-mail',
  'notif.via.sms': 'Trimis prin SMS',
  'notif.via.telegram': 'Trimis pe Telegram',
  'notif.via.viber': 'Trimis pe Viber',
  'notif.via.whatsapp': 'Trimis pe WhatsApp',
  'notif.logged': 'Salvat în cabinet',
  'notif.queued': 'Îl vom trimite dimineața',
  'notif.new': 'Nou',
  'notif.unread': 'Notificări noi: {n}',
  'notif.more': 'Arată cele anterioare',
  'notif.today': 'Astăzi',
  'notif.yesterday': 'Ieri',
  'step.accepted': 'Am preluat dosarul',
  'step.docs_collecting': 'Pregătim documentele',
  'step.docs_ready': 'Documentele sunt gata',
  'step.picked_up': 'Am preluat trupul',
  'step.in_transit': 'Pe drum',
  'step.border_crossed': 'Am trecut frontiera',
  'step.delivered': 'Am ajuns la destinație',
  'step.burial': 'Înmormântare',
  'step.hint.accepted': 'Am preluat dosarul și lucrăm deja la el.',
  'step.hint.docs_collecting': 'Pregătim documentele necesare. Dacă vom avea nevoie de ceva de la dumneavoastră, vă vom scrie.',
  'step.hint.docs_ready': 'Documentele sunt gata. Pregătim pasul următor.',
  'step.hint.picked_up': 'Ne vom ocupa de tot ce este necesar.',
  'step.hint.in_transit': 'Vă vom anunța când vom trece frontiera și când vom ajunge.',
  'step.hint.in_transit_local': 'Vă vom anunța când vom ajunge.',
  'step.hint.border_crossed': 'Frontiera a rămas în urmă. Vă vom anunța când vom ajunge.',
  'step.hint.delivered': 'Am ajuns. Managerul vă va contacta în privința pașilor următori.',
  'step.hint.burial': 'Suntem alături dacă aveți nevoie de ajutor. Îi puteți scrie managerului în chat.',
  'event.step': 'Pas nou: {step}',
  'feedback.title': 'Cum ne-am descurcat?',
  'feedback.intro': 'Câteva cuvinte de la dumneavoastră ne vor ajuta să fim mai atenți cu alte familii.',
  'feedback.rating': 'Nota de la 1 la 5',
  'feedback.rate': '{n} din 5',
  'feedback.scale': '1 — rău, 5 — foarte bine',
  'feedback.text': 'Ce am fi putut face mai bine? (opțional)',
  'feedback.optOut': 'Nu-mi mai trimiteți astfel de solicitări',
  'feedback.submit': 'Trimiteți răspunsul',
  'feedback.sending': 'Trimitem…',
  'feedback.pickRating': 'Vă rugăm să alegeți o notă.',
  'feedback.thanks': 'Vă mulțumim. Răspunsul dumneavoastră este important pentru noi.',
  'feedback.expired': 'Termenul pentru răspuns a expirat. Îi puteți scrie oricând managerului în cabinet.',
  'feedback.optedOut': 'Ați renunțat la astfel de solicitări, așa că nu le vom mai trimite.',
  'feedback.optedOutDone': 'Nu vă vom mai trimite astfel de solicitări.',
  'feedback.notFound': 'Linkul nu este valabil. Dacă doriți să vă împărtășiți impresiile, scrieți-i managerului în cabinet.',
  'feedback.card': 'Părerea dumneavoastră',
  'feedback.cardIntro': 'Dacă aveți un minut, spuneți-ne cum ne-am descurcat.',
  'feedback.toCabinet': 'Mergeți la cabinet',
  'privacy.feedbackTitle': 'Solicitări de părere',
  'privacy.feedbackHint': 'După încheierea dosarului, vă putem întreba o singură dată cum ne-am descurcat.',
  'privacy.feedbackOptOut': 'Nu-mi trimiteți solicitări de părere',
  'privacy.saved': 'Salvat.',
  'site.contacts': 'Contactați-ne',
};
